










































/* eslint-disable @typescript-eslint/camelcase */

import { FundingSource } from '@/types/Payments'
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { exists } from '@/util/inputValidation'
import { updateFundingSource } from '@/services/payments'

@Component
export default class RemoveFundingSourceDialog extends Vue {

  isValid = false
  loading = false
  rules = {
    name: [exists('You must enter a name for your account.')],
  }

  @Prop({ default: false }) readonly opened!: boolean
  @Prop(Object) readonly fundingSource!: FundingSource

  editedFundingSource: FundingSource | null = null

  @Watch('opened')
  dialogOpened() {
    this.editedFundingSource = {...this.fundingSource}
  }

  closeDialog() {
    this.$emit('update:opened', false)
  }

  async updateFundingSource() {
    this.loading = true
    try {
      await updateFundingSource(this.$store, this.editedFundingSource as FundingSource)
      this.closeDialog()
    }
    finally {
      this.loading = false 
    }
  }
}
